<template>
    <div :class="[
              'epg__timeslots',
              'epg__channel-row', {
              'epg__channel-row--expanded': channel._isSelected
              }]"
         :style="`height:${(channel._isSelected) ? defaultTimeSlotHeight+expandedSlotHeight : defaultTimeSlotHeight}px`"
         ref="ch" >
        <div v-if="inViewport">
            <Program
                    v-for="(n, index) in channel.slots"
                    v-bind:key="n.id"
                    :timeline-rect="timelineRect"
                    :horizontal-debounce="horizontalDebounce"
                    :is-grabbed="isGrabbed"
                    :program="n"
                    :pixels-per-minute="pixelsPerMinute"
                    :container-pos="containerPos"
                    :timeline-width="timelineWidth"
                    :selectProgram="selectProgram"
                    :more-label="moreLabel"
                    :less-label="lessLabel"
                    :close-slot="closeSlot"
                    :set-expanded-slot-height="setExpandedSlotHeight"
                    :expanded-slot-height="expandedSlotHeight"
                    :show-program-loader="showProgramLoader"
                    :selected-program="selectedProgram"
                    :description-truncation-point="descriptionTruncationPoint"
            />
        </div>
    </div>
</template>

<script>
  import Program from '../Program/Program.vue'

  export default {
    name: 'epg-channel-row',
    components: {'Program': Program},
    props: ['timelineRect', 'horizontalDebounce', 'setChannelVisibility', 'isGrabbed', 'preCacheHeight', 'isScrolling', 'channel', 'program', 'pixelsPerMinute', 'selectProgram', 'containerPos', 'timelineWidth', 'showProgramLoader', 'selectedProgram', 'moreLabel', 'lessLabel', 'closeSlot', 'defaultTimeSlotHeight', 'defaultExpandedSlotHeight', 'expandedSlotHeight', 'setExpandedSlotHeight', 'descriptionTruncationPoint'],
    data () {
      return {
        inViewport: false
      }
    },
    mounted () {
      // self.setChannelVisibility(self.channel.id, self.isElementInViewport())
      requestAnimationFrame(() => {
        this.inViewport = this.isElementInViewport()
      })
    },
    watch: {
      isScrolling: function (val) {
        // self.setChannelVisibility(self.channel.id, self.isElementInViewport())
        requestAnimationFrame(() => {
          this.inViewport = this.isElementInViewport()
        })
      }
    },
    methods: {
      isElementInViewport  () {
        const self = this
        const rect = self.$refs.ch.getBoundingClientRect()

        return (
          rect.top >= -self.preCacheHeight &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + self.preCacheHeight
        )
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ChannelRow.vue?36a47555